export default __webpack_public_path__ + "static/media/UnitsOrange.455e2ff8.png";